import { render, staticRenderFns } from "./LavageRemorque.vue?vue&type=template&id=448c28f4&scoped=true&"
import script from "./LavageRemorque.vue?vue&type=script&lang=js&"
export * from "./LavageRemorque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c28f4",
  null
  
)

export default component.exports